import React, { useEffect, useState } from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../rules-regulations.css";
import API_URL from "../../config/constant";
import BannerGroupOfThree from "../../assets/images/banner/BANNER-GROUP-OF-3.jpg";

export default function RegistrationGroup() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);

    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/registration-group?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res);
            } catch (error) {
                setData(t("registrationGroup.content", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);

    return (
        <div className="text-white md:px-0 px-4 bg-white pb-24 md:pb-36">
            {/* <div className="w-full mt-[86px] md:mt-[109px] 2xl:mt-[136px] overflow-hidden">
                <img
                    src={BannerGroupOfThree}
                    alt="Banner Group of 3"
                    className="w-full h-auto object-cover"
                />
            </div> */}
            <div className="relative h-[240px] md:h-[300px] bg-brand-blue bg-contain md:bg-cover bg-no-repeat flex justify-center items-center mt-[86px] md:mt-[109px] 2xl:mt-[136px]">
                <PageHeadline title={t('registrationGroup.title')} />
            </div>
            {/* <ComingSoonBanner /> */}
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-center mt-8">
                <span className="text-brand-blue">{t("registrationGroup.subTitle")}</span>
            </h2>
            <div className="bg-white 2xl:px-0 md:px-14 px-0 mt-8 md:mt-16">
                <div className="bg-white container mx-auto px-4 w-full font-poppins text-brand-blue">
                    <div className="flex md:flex-row flex-col gap-x-24 mt-10">
                        <div className="flex flex-col md:gap-y-10 gap-y-5 mb-10">
                            {Array.isArray(data) && data.map((parent, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentIndex(index)}
                                    className={`uppercase text-start w-52 text-lg ${currentIndex === index
                                        ? "text-brand-blue border-b border-b-brand-blue font-bold"
                                        : "text-neutral-500 font-normal border-none"
                                        }`}
                                >
                                    {parent.title}
                                </button>
                            ))}
                        </div>
                        <div>
                            <ol className="font-light list-decimal leading-loose max-md:px-4">
                                {data && data[currentIndex]?.data && data[currentIndex].data.map((text, key) => (
                                    <li className="text-justify" key={key} dangerouslySetInnerHTML={{ __html: text.desc }}></li>
                                ))}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="font-evil text-white w-full flex justify-center items-center mt-16 md:mt-24">
                {/* Centered button */}
                <button className="relative bg-brand-blue border-2 border-brand-orange px-10 py-6 flex justify-center items-center text-center" onClick={() => window.location.href = '/registration-group/form'} disabled>
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold">
                        <span className="text-white">{t("registrationGroup.button1")}</span>
                        <span className="text-brand-orange ml-2 md:ml-3">{t("registrationGroup.button2")}</span>
                    </h2>
                </button>
            </div>
        </div>
    );
}
